import utils from "../../../src/js/utils";

var maps = {
	init: function () {
		var mapsWrapper = document.querySelectorAll(".google-maps-wrapper");

		if (mapsWrapper.length > 0) {
			utils.forEach(mapsWrapper, function (index, map) {
				var apiKey = JSON.parse(map.getAttribute("data-map")).api_key;

				utils.loadScript(
					"https://maps.googleapis.com/maps/api/js?key=" + apiKey,
					false,
					function () {
						maps.startMap(map);
					},
					true
				);
			});
		}
	},

	startMap: function (map) {
		var mapDatas = JSON.parse(map.getAttribute("data-map")),
			markers = mapDatas.markers,
			zoom = parseInt(mapDatas.zoom),
			maxZoom = parseInt(mapDatas.max_zoom),
			bounds = new window.google.maps.LatLngBounds(),
			styles = "terrain";
			if(mapDatas.custom_style){
				styles = JSON.parse(mapDatas.custom_style);
			}

		var mapInstance = new window.google.maps.Map(map, {
			center: latLng,
			zoom,
			styles,
			disableDefaultUI: true,
		});

		mapInstance.setOptions({ maxZoom });

		var markerInstances = [];

		for (let index = 0; index < markers.length; index++) {
			var marker = markers[index],
				latitude = marker.latitude,
				longitude = marker.longitude,
				link = marker.link,
				icon = marker.icon,
				latLng = new window.google.maps.LatLng(
					parseFloat(latitude),
					parseFloat(longitude)
				);

			var markerInstance = new window.google.maps.Marker({
				position: latLng,
				map: mapInstance,
				icon: {
					url: icon,
					scaledSize: new window.google.maps.Size(60, 60),
				},
				url: link,
			});

			markerInstances.push(markerInstance);

			bounds.extend(latLng);

			markerInstances[index].addListener("click", () => {
				window.open(markerInstances[index].url);
			});
		}

		mapInstance.fitBounds(bounds); //centro e zoommo in automatico la mappa
	},
};

utils.domReady(function () {
	maps.init();
});
